import { useCallback } from "react";
import dagre from "dagre";

const NODE_WIDTH = 220;
const NODE_HEIGHT = 70;

export default function useAutoLayout() {
    const getLayoutedElements = useCallback((nodes, edges) => {
        const g = new dagre.graphlib.Graph();
        g.setDefaultEdgeLabel(() => ({}));
        g.setGraph({ rankdir: "LR", nodesep: 80, ranksep: 150 });

        nodes.forEach((node) => {
            g.setNode(node.id, { width: NODE_WIDTH, height: NODE_HEIGHT });
        });

        edges.forEach((edge) => {
            g.setEdge(edge.source, edge.target);
        });

        dagre.layout(g);

        const layoutedNodes = nodes.map((node) => {
            const nodeWithPosition = g.node(node.id);
            return {
                ...node,
                position: {
                    x: nodeWithPosition.x - NODE_WIDTH / 2,
                    y: nodeWithPosition.y - NODE_HEIGHT / 2,
                },
            };
        });

        return { nodes: layoutedNodes, edges };
    }, []);

    return { getLayoutedElements };
}
